<template>
  <dt-wrap>
    <div class="ds-table-container component-props mbl">
      <h2
        :id="component"
        class="index-this-heading component-prop-h mts text-l"
      >
        <a :data-id="component"></a>{{ component }}
      </h2>
      <table class="proptable">
        <thead>
          <tr>
            <th class="prop">Property</th>
            <th class="type">Type</th>
            <th class="def">Default</th>
            <th class="desc">Description</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(prop, index) in properties" :key="index">
            <tr>
              <td class="prop">
                <code>{{ prop.name }}</code>
              </td>
              <td class="type">{{ prop.type }}</td>
              <td class="def">
                <code v-if="prop.defaultValue">{{ prop.defaultValue }}</code>
              </td>
              <td class="desc">{{ prop.description }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </dt-wrap>
</template>

<script>
import { defineComponent, inject } from "vue";
import { Component } from "vue-facing-decorator";

export default defineComponent({
  name: "PropTable",
  props: {
    component: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      properties: []
    };
  },
  setup() {},
  methods: {
    dashToCamelCase: function (myStr) {
      return myStr.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
      });
    },
    getPropValues: function (propObject, name) {
      // console.log("PROPOBJECT and name", [propObject, name]);
      let result = {
        name: name,
        type: undefined,
        defaultValue: undefined,
        description: undefined
      };

      try {
        if (propObject.length > 0 && typeof propObject != "function") {
          result.type = propObject.map((t) => t.name).join(" or ");
        } else if (typeof propObject === "object") {
          result.defaultValue = propObject.default
            ? propObject.default
            : undefined;
          result.type =
            propObject.type && typeof propObject.type === "string"
              ? propObject.type
              : propObject.type && propObject.type.name
                ? propObject.type.name
                : typeof propObject.type === "object"
                  ? propObject.type
                      .map((t) => (t.name ? t.name : undefined))
                      .join(" or ")
                  : propObject.name
                    ? propObject.name
                    : undefined;
          result.description = propObject.description
            ? propObject.description
            : undefined;
        }
      } catch (e) {
        console.warn(e);
      }

      return result;
    }
  },
  mounted: function () {
    let t = this;
    const compo = this.dashToCamelCase(this.component).toLowerCase();
    const components = this.$.appContext.components;
    const componentNames = Object.keys(components);
    let theComponent = componentNames
      .filter(function (componentName) {
        let e = components[componentName].name;
        if (e && typeof e === "string") {
          return e.toLowerCase() === compo;
        }
      })
      .map(function (componentName) {
        return components[componentName];
      });

    if (!theComponent || theComponent.length < 1) {
      theComponent = componentNames
        .filter(function (componentName) {
          let e = components[componentName].name;
          if (e && typeof e === "string") {
            return e === t.component;
          }
        })
        .map(function (componentName) {
          return components[componentName];
        });
    }

    const props =
      theComponent[0] && theComponent[0].props
        ? theComponent[0].props
        : undefined;
    if (props) {
      Object.keys(props).forEach((key) => {
        this.properties.push(this.getPropValues(props[key], key));
      });
    }
  }
});
</script>
